import {
  AppNavigation as AppNavigationPhase1,
  useIsFoundationalPillarsNavPhase1Enabled,
} from '@ms/yammer-features-app-navigation';
import AppNavigation from '@ms/yammer-web-components/dist/navigation/AppNavigation';
import NavigationCommunities from '@ms/yammer-web-components/dist/navigation/NavigationCommunities';
import React, { ReactNode, useCallback } from 'react';

type UseGetNavigationCallback = () => () => ReactNode;
export const useGetNavigationCallback: UseGetNavigationCallback = () => {
  const isFoundationalPillarsNavPhase1Enabled = useIsFoundationalPillarsNavPhase1Enabled();

  return useCallback(
    () =>
      isFoundationalPillarsNavPhase1Enabled ? (
        <AppNavigationPhase1 communitiesNavLinksContent={<NavigationCommunities />} />
      ) : (
        <AppNavigation />
      ),
    [isFoundationalPillarsNavPhase1Enabled]
  );
};
